import { Injectable, inject } from '@angular/core';
import { IrisUserService } from '@iris/common/services/user.service';

@Injectable({
  providedIn: 'root',
})
export class IrisLocaleService {
  private readonly userService = inject(IrisUserService);
  private readonly localeMap: Record<string, string> = {
    en: 'EN_GB',
    de: 'DE_DE',
    gsw: 'DE_CH',
    fr: 'FR_FR',
    es: 'ES_ES',
    ru: 'RU_RU',
    it: 'IT_IT',
    bg: 'BG_BG',
    hr: 'HR_HR',
    cs: 'CS_CZ',
    da: 'DA_DK',
    nl: 'NL_NL',
    hu: 'HU_HU',
    me: 'SR_ME',
    pl: 'PL_PL',
    pt: 'PT_PT',
    ro: 'RO_RO',
    sr: 'SR_RS',
    sk: 'SK_SK',
    sl: 'SL_SI',
    sv: 'SV_SE',
  };

  getCurrentLocale(): string {
    return this.userService.me?.language;
  }

  getLocaleFormatted(): string {
    const language = this.getCurrentLocale();
    if (!language) { return 'DE_DE'; }
    return this.localeMap[language.toLowerCase()] ?? 'DE_DE';
  }
}
